// extracted by mini-css-extract-plugin
export var box = "_52-0";
export var check = "_52-1";
export var checkboxButton = "_52-6";
export var checkboxGroup = "_52-5";
export var disabled = "_52-7";
export var ghost = "_52-9";
export var input = "_52-2";
export var label = "_52-4";
export var normal = "_52-8";
export var uncheck = "_52-3";